function AppSkeleton() {
  return (
    <div className="flex h-screen bg-background">
      <div className="hidden md:flex md:w-64 bg-background border-r flex-col">
        {/* Company */}
        <div className="p-4 border-b flex items-center gap-3">
          <div className="w-6 h-6 rounded-full bg-accent  animate-pulse" />
          <div className="h-4 w-32 bg-accent  animate-pulse rounded" />
        </div>

        {/* Search */}
        <div className="p-3 border-b">
          <div className="h-9 bg-accent  animate-pulse rounded" />
        </div>

        {/* Menu */}
        <div className="flex-1 p-3 space-y-5">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="flex items-center gap-4">
              <div className="w-4 h-4 bg-accent  animate-pulse rounded" />
              <div className="h-4 w-32 bg-accent  animate-pulse rounded" />
            </div>
          ))}
        </div>

        {/* User */}
        <div className="p-4 border-t flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-accent  animate-pulse" />
          <div className="h-4 w-24 bg-accent  animate-pulse rounded" />
        </div>
      </div>

      {/* Main Area */}
      <div className="flex-1 flex flex-col">
        {/* Topbar */}
        <div className="h-14 border-b bg-background px-4 md:px-6 flex items-center justify-between">
          {/* Mobile menu icon skeleton */}
          <div className="flex items-center gap-4">
            <div className="w-6 h-6 bg-accent  animate-pulse rounded md:hidden" />
            <div className="h-5 w-40 md:w-48 bg-accent  animate-pulse rounded" />
          </div>

          <div className="h-8 w-20 md:w-24 bg-accent  animate-pulse rounded" />
        </div>

        {/* Content */}
        <div className="p-4 md:p-6 flex flex-col gap-6">
          {/* Small card */}
          <div className="h-28 md:h-32 w-full bg-accent  animate-pulse rounded" />

          {/* Large report area */}
          <div className="h-56 md:h-64 lg:h-72 w-full bg-accent  animate-pulse rounded" />
        </div>
      </div>
    </div>
  );
}

export default AppSkeleton;
